import { render, staticRenderFns } from "./WebsocketTester.vue?vue&type=template&id=0dc6509b"
import script from "./WebsocketTester.vue?vue&type=script&lang=js"
export * from "./WebsocketTester.vue?vue&type=script&lang=js"
import style0 from "./WebsocketTester.vue?vue&type=style&index=0&id=0dc6509b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports